//
// Tools

import Ajax from '../tools/Ajax';
import Events from '../tools/Events';
import Constants from '../tools/Constants';
import ABuilder from '../tools/ABuilder';
import Tools from '../tools/Tools';
import URL from '../tools/URL';

export default class Search {

	constructor() {
		this.body = $('body');
		this.input = $('.search-text');
		this.fakeInput = $('.search-input');
		this.fakeButton = $('.button-search');
		this.container = $('.search-overlay');
		this.closeButton = $('.search-close');
		this.parentResults = $('.search-results-container');
		this.results = $('.search-results-container').find('.row');
		this.empty = $('.search-empty-container');
		this.arrow = this.container.find('.snookfun-icon-arrow-right');
		this.loader = $('.cssload-search-overlay-wrapper');

		this.parentResults.addClass('hidden');
		this.empty.addClass('hidden');
		this.hideLoader();

		this.language = this.input.data('language');

		//states
		this.active = false;
		this.lastSearch = null;

		this.searchTimer = null;
		this.closeTimer = null;

		this.attachEvents();

	}

	attachEvents() {

		this.fakeInput.on('click focus', () => {
			this.showSearch();
		});

		this.fakeButton.on('click', () => {
			this.showSearch();
		});

		this.closeButton.on('click', () => {
			this.hideSearch();
		});

		this.input.on('focus', (event) => {
			this.onFocus(event);
		});

		// this.input.on('blur', (event) => {
		//     this.onBlur(event);
		// });

		this.input.on('keydown', (event) => {
			this.onKeyDown(event);
		});

		this.input.on('keyup', (event) => {
			this.onKeyUp(event);
		});

		$(document).on('keydown keypress keyup', (event) => {
			if (event.keyCode == 27) {
				this.hideSearch();
			}
		});

	}

	showSearch() {
		this.body.addClass('search-opened');
		this.container.removeClass('hidden');
		this.input.focus();
	}

	hideSearch() {
		this.body.removeClass('search-opened');
		this.container.addClass('hidden');
		this.disableSearch();
	}

	onFocus(event) {

		window.clearTimeout(this.closeTimer);

		this.enableSearch();

	}

	onBlur(event) {

		window.clearTimeout(this.closeTimer);

		if (this.input.val().length === 0) {
			return;
		}

		this.closeTimer = window.setTimeout(function () {

			if (this.active) {
				this.disableSearch();
			} else {
				console.log('Can not disable, as not active ....');
			}

		}.bind(this), 250);

	}

	onKeyDown(event) {

		let key = event.keyCode || event.which;

		if (this.active && key === 27) {

			this.stopSearching();

			this.disableSearch();

		}
	}

	onKeyUp(event) {

		//reset timer
		this.stopSearching();

		//skip if search string has not changed!
		if (this.lastSearch === this.input.val()) {
			console.log('Skip', this.lastSearch, this.input.val());
			return;
		}

		let string = this.getCleanedSearch();

		if (string.length > 1) {
			this.startSearching();
		} else if (string.length == 1) {
			this.stopSearching();
		} else {
			this.emptyResults();
		}

	}

	query(aTypes = []) {

		let string = String(this.getCleanedSearch()).toLowerCase();

		this.loading = true;
		this.lastSearch = string;
		this.showLoader();

		let data = {
			action: 'search',
			q: string,
			L: this.language
		};

		this.request = $.get(URL.getUrlForAPI(), data, (transport) => {
			// --
		}).always((aData) => {

			// if searching is already false, we somehow already stopped it or we have multiple request running at the same time.
			if (this.loading === false) {
				return;
			}

			// if we blur out of the input field fast enough, the request could still be running, so we check it here
			if (this.active === false) {
				return;
			}

			this.loading = false;

			// -- TODO : Hide Spinner/Loader

			let data = {};

			if (aData.responseJSON) {
				data = aData.responseJSON;
			} else {
				data = aData;
			}

			if (data.result) {
				this.buildResult(data.data);
			}

		});

	}

	buildResult(aData) {

		this.hideLoader();

		if (aData.count === 0) {

			this.parentResults.addClass('hidden');
			this.empty.removeClass('hidden');

		} else {

			this.empty.addClass('hidden');

			let results = [];

			for (let key in aData.records) {

				if (aData.records.hasOwnProperty(key)) {

					let category = aData.records[key];
					//
					// let resultItems = ABuilder('div', {'class': 'category-items'});
					//
					// let resultCategory = ABuilder('div', {'class': 'result-category'}, [
					//     ABuilder('div', {'class': 'category-title'}, category.label),
					//     resultItems
					// ]);

					for (let itemKey in category.items) {

						if (category.items.hasOwnProperty(itemKey)) {

							let abstract = '';
							let thumbnail = '';

							let item = category.items[itemKey];

							if (item.label.length > 30) {
								item.label = item.label.substring(0, 30) + "...";
							}
							if (item.abstract !== undefined) {
								if (item.abstract.length > 70) {
									abstract = item.abstract.substring(0, 70) + "...";
								}
								else {
									abstract = item.abstract;
								}
							}
							if (item.thumbnail !== undefined) {
								thumbnail = item.thumbnail;
							}

							let singleItem = ABuilder('div', {'class': 'col-xs-12 col-sm-6 col-md-6 col-lg-4'}, [
								ABuilder('a', {
										'class': 'snookfun-search-result-card',
										'href': '/?type=1002&page=' + item.link
									}, [
										ABuilder('div', {'class': 'search-result-image embed-responsive embed-responsive-16by9'}, [
											ABuilder('div', {
												'class': 'embed-responsive-item',
												'style': 'background-image: url(' + item.thumbnail + ')'
											})
										]),
										ABuilder('div', {'class': 'search-result-info'}, [
											ABuilder('div', {'class': 'search-result-category'}, item.category),
											ABuilder('div', {'class': 'search-result-title'}, item.label),
											ABuilder('div', {'class': 'search-result-subtitle'}, item.date),
											ABuilder('div', {'class': 'search-result-text hidden-xs'}, abstract),
											ABuilder('div', {'class': 'search-result-link hidden-xs'}, 'Plus d\'informations')
										])
									]
								)]
							);

							results.push(singleItem);

						}

					}


				}

			}

			this.results.html(results);
			this.parentResults.removeClass('hidden');

		}

	}

	getCleanedSearch() {
		return this.input.val();
	}

	stopSearching() {

		if (this.request) {
			this.request.abort();
		}

		//this.hideLoader();
		this.loading = false;
		window.clearTimeout(this.searchTimer);

	}

	startSearching() {

		this.stopSearching();

		this.active = true;

		this.input.addClass('active');

		// this.showLoader();

		this.searchTimer = window.setTimeout(function () {

			this.query();

		}.bind(this), 350);

	}

	enableSearch() {
		this.active = true;
	}

	disableSearch() {
		this.stopSearching();
		this.input.val('');
		this.input.blur();
		this.hideLoader();
		this.empty.addClass('hidden');

		this.input.removeClass('active');
		this.results.html('');

		this.active = false;

	}

	emptyResults() {
		this.input.removeClass('active');
		this.results.html('');
		this.lastSearch = '';
	}

	showLoader() {
		this.arrow.addClass('hidden');
		this.loader.removeClass('hidden');
	}

	hideLoader() {
		this.arrow.removeClass('hidden');
		this.loader.addClass('hidden');
	}

}